import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { LeaveApplication } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import { Badge } from "@/components/ui/badge/badge";
import { DataTableRowActions } from "./data-table-row-actions";
import { datesMatch } from "@/utils";
import { cn } from "@/lib/utils";

export const columns: ColumnDef<LeaveApplication, any>[] = [
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => (
      <div className="w-[180px] flex flex-col">
        <span>{row.index + 1}</span>
        <span className="text-xs">
          (Created at - {format(row.getValue("createdAt"), "PPP")} )
        </span>
      </div>
    ),
    enableSorting: false,
    enableHiding: false,

    filterFn: (row, id, value) => {
      return datesMatch(row.getValue(id), value);
    },
  },
  {
    accessorKey: "employeeName",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Employee" />
    ),
    cell: ({ row }) => (
      <div className="flex flex-col gap-1">
        <span>{row.getValue("employeeName")}</span>
        <span className="text-xs">{row.original?.employeeEmail}</span>
      </div>
    ),
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
    enableSorting: false,
  },

  {
    accessorKey: "leaveType",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Leave Type" />
    ),
    cell: ({ row }) => <div>{row.getValue("leaveType")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const status = row.getValue("status") as string;

      return (
        <div>
          <Badge
            className={cn(
              status === "Pending" && "bg-blue-500",
              status === "Approved" && "bg-emerald-500",
              status === "Rejected" && "bg-red-500"
            )}
          >
            {row.getValue("status")}
          </Badge>
        </div>
      );
    },
    enableColumnFilter: false,
    enableSorting: false,
  },
  {
    accessorKey: "reason",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Reason" />
    ),
    cell: ({ row }) => <div>{row.getValue("reason")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "startDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Start Date" />
    ),
    cell: ({ row }) => <div>{format(row.getValue("startDate"), "PPP")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "endDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="End Date" />
    ),
    cell: ({ row }) => <div>{format(row.getValue("endDate"), "PPP")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
